var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({
    backgroundImage: _vm.backgroundImage,
  })},[_c('div',{staticClass:"lg-avatar"},[_c('img',{attrs:{"src":_vm.influencer.url_foto}}),_c('h1',[_vm._v(_vm._s(_vm.influencer.nome_midia))])])])}
var staticRenderFns = []

export { render, staticRenderFns }